import React from 'react';
import PropTypes from 'prop-types';
import { Edit, Exit, Check1 } from '@origo_vl_banking/icons';
import { EditButton, EditActionsWrapper, SaveActionsWrapper } from '../styled-components';

const EditActions = ({
  editMode, setState, handleSave, handleCancel, search,
}) => {
  const edit = (
    <EditButton ie11GridColumn={1} onClick={() => setState({ editMode: true })}>
      <Edit size={25} />
    </EditButton>
  );

  const save = (
    <SaveActionsWrapper>
      <EditButton ie11GridColumn={1} onClick={handleSave}>
        <Check1 size={25} />
      </EditButton>
      <EditButton ie11GridColumn={2} onClick={handleCancel}>
        <Exit size={25} />
      </EditButton>
    </SaveActionsWrapper>
  );

  const actions = editMode ? save : edit;
  return <EditActionsWrapper search={search}>{actions}</EditActionsWrapper>;
};

EditActions.propTypes = {
  editMode: PropTypes.bool.isRequired,
  setState: PropTypes.func.isRequired,
  handleSave: PropTypes.func.isRequired,
  handleCancel: PropTypes.func.isRequired,
  search: PropTypes.bool,
};

EditActions.defaultProps = {
  search: false,
};

export default EditActions;
